import useLocale from "@Hooks/selector/useLocale";
import useIsCompanyStore from "@Hooks/selector/useIsCompanyStore";

export default function useIsModifiedMenuDisplayed() {
    const locale = useLocale()
    const isCompanyStore = useIsCompanyStore()

    return !isCompanyStore && (locale === "en" || locale === "hr")
}